import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, filter, switchMap, tap } from 'rxjs';
import { EnvironmentLoaderService } from './environment-loader.service';
import { SnackbarService } from 'ok-angular-shared/components';

export interface FlagResult {
  result: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  private http = inject(HttpClient);
  private environmentLoaderService = inject(EnvironmentLoaderService);
  private snackbarService = inject(SnackbarService);

  private apiUrl: string;

  constructor() {
    this.apiUrl = this.environmentLoaderService.config['serviceBaseUrl'] + '/api/v1/feature-flags';
  }

  getFeatureFlag(flagName: string): Observable<FlagResult> {
    return this.http.get<FlagResult>(`${this.apiUrl}/${flagName}`);
  }

  executeIfFlagIsTrue<T>(flagName: string, disabledMessage: string, action: () => Observable<T>): Observable<T> {
    return this.getFeatureFlag(flagName).pipe(
      tap(flag => {
        if (!flag.result) {
          this.snackbarService.info(disabledMessage);
        }
      }),
      filter(flag => flag.result),
      switchMap(() => action())
    );
  }
}
